/*! StartNoStringValidationRegion Constants */
export const storeName = "keyval";
export const dbPrefix = "glow-";
/*! EndNoStringValidationRegion */
